import { Icon } from './Brand.jsx';
import { liveDomain } from '../lib/slots.js';

function firstDomain(site) {
  return liveDomain(site);
}

export function sitePreviewUrl(site) {
  return site?.slots?.live?.url || (firstDomain(site) ? `https://${firstDomain(site)}` : null);
}

export default function SitePreview({ site, compact = false }) {
  const url = sitePreviewUrl(site);
  const domain = firstDomain(site);

  return (
    <section className={`site-preview${compact ? ' site-preview--compact' : ''}`} aria-label={`Preview of ${site.name}`}>
      <div className="site-preview__bar">
        <span className="site-preview__lights" aria-hidden="true"><i /><i /><i /></span>
        <span className="site-preview__address mono">{domain || 'No domain connected'}</span>
        {url ? (
          <a className="site-preview__open" href={url} target="_blank" rel="noreferrer" aria-label={`Open ${domain} in a new tab`}>
            <Icon name="external" size={15} />
          </a>
        ) : null}
      </div>
      <div className="site-preview__viewport">
        {url ? (
          <iframe
            src={url}
            title={`${site.name} live site`}
            loading="lazy"
            sandbox="allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
          />
        ) : (
          <div className="site-preview__empty">
            <span>{site.name}</span>
            <small>Connect a domain to see the live site here.</small>
          </div>
        )}
      </div>
    </section>
  );
}
